module.exports = __webpack_public_path__ + "static/media/image 9.56324d07.svg";